import { render, staticRenderFns } from "./PersonnelTab.vue?vue&type=template&id=5c8d132a&"
import script from "./PersonnelTab.vue?vue&type=script&lang=js&"
export * from "./PersonnelTab.vue?vue&type=script&lang=js&"
import style0 from "./PersonnelTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports